export function getColumnCellsSelected(_a) {
    var columnIndex = _a.columnIndex, columns = _a.columns, rows = _a.rows;
    var _b, _c;
    var selectedItems = [];
    for (var rowIndex = 0; rowIndex < rows.length; rowIndex++) {
        selectedItems.push({
            rowIndex: rowIndex,
            columnIndex: columnIndex,
            rowKey: (_b = rows[rowIndex]) === null || _b === void 0 ? void 0 : _b.key,
            columnKey: (_c = columns[columnIndex]) === null || _c === void 0 ? void 0 : _c.key
        });
    }
    return selectedItems;
}
export function getRowCellsSelected(_a) {
    var rowIndex = _a.rowIndex, columns = _a.columns, rows = _a.rows;
    var selectedItems = [];
    for (var columnIndex = 0; columnIndex < columns.length; columnIndex++) {
        selectedItems.push({
            rowIndex: rowIndex,
            columnIndex: columnIndex,
            rowKey: rows[rowIndex].key,
            columnKey: columns[columnIndex].key
        });
    }
    return selectedItems;
}
export function isAllColumnSelected(_a) {
    var columnIndex = _a.columnIndex, isSelected = _a.isSelected, columns = _a.columns, rows = _a.rows, data = _a.data;
    var _b;
    var countTileSelected = 0;
    for (var rowIndex = 0; rowIndex < rows.length; rowIndex++) {
        if (isSelected({
            rowIndex: rowIndex,
            columnIndex: columnIndex,
            data: data,
            rowKey: (_b = rows[rowIndex]) === null || _b === void 0 ? void 0 : _b.key,
            columnKey: columns[columnIndex].key
        })) {
            countTileSelected++;
        }
    }
    return countTileSelected === rows.length;
}
export function isAllRowSelected(_a) {
    var rowIndex = _a.rowIndex, isSelected = _a.isSelected, columns = _a.columns, rows = _a.rows, data = _a.data;
    var _b;
    var countTileSelected = 0;
    for (var columnIndex = 0; columnIndex < columns.length; columnIndex++) {
        if (isSelected({
            rowIndex: rowIndex,
            columnIndex: columnIndex,
            data: data,
            rowKey: (_b = rows[rowIndex]) === null || _b === void 0 ? void 0 : _b.key,
            columnKey: columns[columnIndex].key
        })) {
            countTileSelected++;
        }
    }
    return countTileSelected === columns.length;
}
//# sourceMappingURL=helpers.js.map